module.exports = __webpack_public_path__ + "static/media/bgCarousel.1fec295d.png";